import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TreeNode from './TreeNode';
import defaultDecorators from './Decorators';
import defaultTheme from './DefaultTheme';
import defaultAnimations from './Animations';

const TreeBeard = ({ data, tabSelected, onToggle, animations, decorators, style }) => (
  <ul style={style.tree.base}>
    {_.map(data, (node, index) => {
      const nodeData = node;
      nodeData.objectType = 'operand';
      return (
        <TreeNode
          key={nodeData.id || index}
          dataId={nodeData.shortText}
          node={nodeData}
          onToggle={onToggle}
          animations={animations}
          decorators={decorators}
          style={style.tree.node}
          tabSelected={tabSelected}
          treeData={data}
        />
      );
    })}
  </ul>
);

TreeBeard.propTypes = {
  style: PropTypes.shape({
    tree: PropTypes.shape({
      base: PropTypes.shape({}),
      node: PropTypes.shape({}),
    }),
  }),
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  animations: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onToggle: PropTypes.func,
  decorators: PropTypes.shape({}),
  tabSelected: PropTypes.string,
};

TreeBeard.defaultProps = {
  style: defaultTheme,
  animations: defaultAnimations,
  decorators: defaultDecorators,
};

export default TreeBeard;
